export default {
  playList: '播放清单',
  yunduanku: '云端库',
  myList: '我的清单',
  searchPlaceholder: '请输入关键词搜索课程',
  searchButton: '搜索',

  saveList: '保存清单',
  sendRes: '发送资源',
  clearList: '清空清单',
  loading: '努力加载中……',
  empty: '空空如也~',

  saveAsList: '存为列表',
  okText: '保存',
  pleaseInputListName: '请输入列表名称',
  max20: '最多20字',
  all: '全部',

  xuekeshuxing: '学科属性',
  ziranshuxing: '自然属性',
  playListEmpty: '请将右侧资源拖动到此处',
  listIsEmpty: '列表为空',
  saveDone: '保存成功',

  resSending: '列表中的资源正在向所选设备发送，你可以在设备状态中查看进度',
  resSendDone: '发送成功',
  clearListTip: '列表清空后，可以继续添加资源到列',
  clearListConfirm: '确定清空列表吗？',
  titleEmpty: '请输入课程名或选择已有课程!',

  // 筛选条件
  resType: '类型',
  cateType: '属性',
  generalCate: '分类',
  phase: '学段',
  generalSubCate: '二级分类',
  subject: '学科',
  grade: '年级',
  volume: '册别',

  alreadyAdded: '已加入',
  addDone: '加入成功',

  cannotFind: '找不到',
  no: '没有',
  prev: '上一个',
  next: '下一个',

  playAddSuccess: '已添加',
  playAddExist: '个已存在',

  deviceIsEmpty: '选中的设备列表为空',
}
